import React from "react";
var __jsx = React.createElement;
import { useAuth } from "@qure/qure-auth";
import { t } from "i18next";
import Image from "next/image";
var Maintenance = function Maintenance() {
  var _error$response;
  var _useAuth = useAuth(),
    error = _useAuth.error,
    isLoading = _useAuth.isLoading;
  var authErrorStatus = error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
  var isUnderMaintenance = !isLoading && (authErrorStatus > 500 || (error === null || error === void 0 ? void 0 : error.code) == "ERR_NETWORK");
  if (!isUnderMaintenance) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-full bg-[#0C1723] flex-col justify-center items-center space-y-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-[312px] h-[232px] md:w-[588px] md:h-[436px]"
  }, /*#__PURE__*/React.createElement(Image, {
    fill: true,
    alt: "error",
    src: "/assets/images/maintenance-image.svg",
    className: "object-contain"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      window.location.reload();
    },
    className: "bg-gray-800 text-teal-300 text-lg md:text-2xl py-5 md:py-6 px-20 rounded-xl cursor-pointer"
  }, t("refresh_page")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center text-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500"
  }, t("under_maintenance")), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500"
  }, t("refresh_after_sometime"))));
};
export default Maintenance;